module.exports = __webpack_public_path__ + "img/2.0d505f70.jpg";